module.exports = __webpack_public_path__ + "img/article_2_4.f923775a.png";